import $ from 'jquery';
import abp from 'abp';
import { notify, localize } from 'linksoft';
const Resx = localize('App', 'Common');

const warningThresholdEvaluatorInitializer = () => {
    $('#warningThresholdEvaluator').on('click', (function (event) {
        event.preventDefault();

        const evaluator = $(this);
        const input = $("#" + evaluator.data('input'));
        const min = $("#" + evaluator.data('target-min'));
        const max = $("#" + evaluator.data('target-max'));

        evaluator.find("i").addClass("fa-spin disabled");

        abp.services.api.projectWarningThresholdEvaluator.evaluate(input.val()).done(result => {
            if (result.success) {
                min.val(result.min);
                max.val(result.max);
                notify.success(Resx.Common.Done);
            } else {
                notify.error(Resx.App.WarningThresholdEvaluationFailed);
            }
        }).fail(() => {
            notify.error(Resx.Common.AjaxError);
        }).always(() => {
            evaluator.find("i").removeClass("fa-spin");
        });

        
    }));
}

export {
    warningThresholdEvaluatorInitializer
}


// WEBPACK FOOTER //
// ./App/components/initializers/warning-threshold-evaluator.js